(function () {
  function getQuantityInput() {
    return document.querySelector('#number, input[name="quantity"]');
  }

  window.increaseValue = function () {
    const input = getQuantityInput();
    if (!input) return;

    const min = Number.parseInt(input.min, 10) || 1;
    const max = Number.parseInt(input.max, 10) || Infinity;
    const current = Number.parseInt(input.value, 10);

    input.value = Math.min(max, Number.isNaN(current) ? min : current + 1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  window.decreaseValue = function () {
    const input = getQuantityInput();
    if (!input) return;

    const min = Number.parseInt(input.min, 10) || 1;
    const current = Number.parseInt(input.value, 10);

    input.value = Math.max(min, Number.isNaN(current) ? min : current - 1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
})();